<!-- Modal Component -->
<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      @click.self="$emit('update:modelValue', false)"
    >
      <div
        class="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-200 rounded-lg shadow-xl max-w-md w-full p-6"
        :class="[maxWidth]"
      >
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold">{{ title }}</h3>
          <slot name="header-right" />
        </div>

        <slot />

        <div v-if="$slots.footer" class="flex justify-end gap-3 mt-4">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: "Modal",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    maxWidth: {
      type: String,
      default: "max-w-md",
    },
  },
  emits: ["update:modelValue"],
};
</script>
